<template>
    <icon icon="fa fa-spinner" size="fa-lg" :spin="true" :pulse="true"/>
</template>

<script>
    import Icon from '@/components/Icons/Icon';

    export default {
        components: {Icon}
    };

</script>



// WEBPACK FOOTER //
// src/components/Loaders/Spinner.vue